import request from '@/utils/request'
import {uuid} from 'vue-uuid'

export function getToken(){
  return request({
    url: "/api/login",
    method: "get"
  });
}

export function login(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/login",
    method: "post",
    data
  });
}

export function logout(){
  return request({
    url: "/api/logout",
    method: "post",
    data: {idempotency: uuid.v1()}
  });
}

export function getUser(){
  return request({
    url: "/api/users",
    method: "get"
  });
}

export function getUserBy(uid){
  return request({
    url: "/api/users/" + uid,
    method: "get"
  });
}

export function getUserByCompany(company_uid){
  return request({
    url: "/api/users/company/" + company_uid,
    method: "get"
  });
}

export function getUserBySuperAdmin(){
  return request({
    url: "/api/users/superadmin",
    method: "get"
  });
}

export function createUser(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/users",
    method: "post",
    data: data
  });
}

export function updateUser(uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/users/"+uid,
    method: "put",
    data: data
  });
}

export function delUser(uid){
  return request({
    url: "/api/users/"+uid,
    method: "delete",
    data: {idempotency: uuid.v1()}
  });
}

export function forgotPassword(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/forgot",
    method: "post",
    data: data
  });
}

export function resetPassword(token, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/resetpassword/"+token,
    method: "put",
    data: data
  });
}

export function register2Factor(){
  return request({
    url: "/api/2fa/register",
    method: "post",
    data: {idempotency: uuid.v1()}
  });
}

export function verify2Factor(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/2fa/verify",
    method: "post",
    data: data
  });
}

export function verifySMS(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/login/sms",
    method: "post",
    data: data
  });
}

export function verify2FactorUser(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/2fa/verify/user",
    method: "post",
    data: data
  });
}

export function status2Factor(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/2fa/status",
    method: "post",
    data: data
  });
}

export function setSupervisor(uid){
  return request({
    url: `/api/users/${uid}/supervisor`,
    method: "put",
    data: {idempotency: uuid.v1()}
  });
}
